@if (currentMeet$ | async; as currentMeet) {
  <form [formGroup]="searchForm">
    <div class="input-group input-group-lg" [ngClass]="{ 'mb-3': searchPages && searchPages.length > 0 }">
      <input class="form-control form-control-lg" type="text" [placeholder]="placeholder" formControlName="name" />

      @if (searchForm.value.name && !searching) {
        <button class="btn btn-primary" type="button" (click)="clearSearch()">
          <fa-icon [icon]="environment.icons.close"></fa-icon>
        </button>
      } @else {
        <span class="input-group-text">
          @if (searching) {
            <fa-icon [icon]="environment.icons.spinner" [fixedWidth]="true" animation="spin"></fa-icon>
          } @else {
            <fa-icon [icon]="environment.icons.search" [fixedWidth]="true"></fa-icon>
          }
        </span>
      }
    </div>
  </form>
  <div class="list-group">
    @if (searchPages && searchPages[pageNum - 1]) {
      @for (event of searchPages[pageNum - 1].events; track event) {
        <a
          #eventItems
          id="event-sidebar-link--{{ event.eventCategory }}-{{ event.id }}"
          [routerLink]="getEventLink(event.eventCategory, event.id, event.isXc)"
          class="list-group-item list-group-item-action"
          routerLinkActive="active"
        >
          <div class="d-flex w-100 mb-1 justify-content-between">
            <h6 class="mb-0" [innerHTML]="event.shortName"></h6>
            @if (event.numVideos) {
              <div style="flex-basis: 65px; text-align: right; font-size: 0.75em">
                <fa-icon [icon]="environment.icons.video" [fixedWidth]="true"></fa-icon>
                {{ event.numVideos }}
              </div>
            }
          </div>
          <div class="d-flex w-100 justify-content-between align-items-baseline">
            <div style="font-size: 0.8em">
              <app-event-date [meetDates]="currentMeet.meetDates" [date]="event.date"></app-event-date>
            </div>
            <app-event-status
              [status]="event.eventStatus"
              [scoreboardStatus]="event.scoreboardStatus"
              [primaryEventGroup]="event.primaryEventGroup"
              [protestManagementProcess]="event.protestMgmt"
            ></app-event-status>
          </div>
        </a>
      }
      @for (searchRecord of searchPages[pageNum - 1].searchRecords; track searchRecord.id) {
        <a
          [routerLink]="getLink(searchRecord.type, searchRecord.id, false)"
          [queryParams]="getQueryParams(searchRecord.type, searchRecord.id)"
          class="list-group-item list-group-item-action"
          routerLinkActive="active"
        >
          <div class="d-flex align-items-center">
            <div>
              <h6 class="mb-1">{{ searchRecord.name }}</h6>
              <div class="mb-0">{{ searchRecord.teamName }}</div>
            </div>
          </div>
        </a>
      }
      @if (collectionSize > pageSize) {
        <ngb-pagination
          class="mt-3"
          [(page)]="pageNum"
          [pageSize]="pageSize"
          [maxSize]="3"
          [collectionSize]="collectionSize"
        />
      }
    }
  </div>
}
